<section class="home" id="scroll-to-top-ref">

  <!-- HEADER -->
  <section class="home__header">

    <div class="first">
      <div class="left">

        <div class="d-flex flex-column">
          <h1>
            Some Dogs Fetch.
          </h1>
          <h1>
            This Dog <span class="text-secondary">Delivers.</span>
          </h1>
        </div>

        <span class="h4-semibold">
          <p class="mb-0">
            Your well-being starts with theirs.
          </p>
          <p class="mb-0">
            Consistent, high-quality nutrition—delivered so your pet stays healthy and you never run out.
          </p>
        </span>

        <button type="button" class="btn btn-lg btn-secondary" [routerLink]="['/shop']">
          Order Now
        </button>

        <section class="list">

          <div>
            <header>
              <span class="material-symbols-outlined">
                verified
              </span>
              <h3>FRESH</h3>
            </header>
            <p>
              Small batch, slow cooked and sold by the pound
            </p>
          </div>

          <div>
            <header>
              <span class="material-symbols-outlined">
                verified
              </span>
              <h3>LOCAL</h3>
            </header>
            <p>
              No ingredients from China, made monthly in Ohio
            </p>
          </div>

          <div>
            <header>
              <span class="material-symbols-outlined">
                verified
              </span>
              <h3>DELIVERED</h3>
            </header>
            <p>
              Locations in Findlay Market, OTR & anywhere there's a porch
            </p>
          </div>

        </section>

      </div>

      <div class="right">
        <div class="content">

          <section class="list-images">
            @for (item of homeImages(); track $index) {
            @if (item.isSelected) {
            <div>
              <span class="material-symbols-outlined text-white">
                north_west
              </span>
            </div>
            } @else {
            <img [src]="item.circle" alt="Image of home page" (click)="changeMainImage(item)">
            }
            }

          </section>

          <img class="back-dog-image" src="/assets/images/landing/home/hero/back-dog.webp" alt="Pet Wants Dog">
          <img class="dog-image" [src]="mainImage()" alt="Pet Wants Dog">

        </div>
      </div>
    </div>

    <div class="second">

      <div class="image">
        <img src="/assets/images/landing/home/hero/van.png" alt="Image of a car">
        <div class="circle">
          <span class="material-symbols-outlined text-white">
            arrow_forward
          </span>
        </div>
      </div>

      <div class="info">

        <h2>
          We're on our way!
        </h2>

        <p>
          Did you run out of food for your furry friend?
        </p>

        @defer (on timer(0.5s)) {
        @if (isSessionLoaded()) {
        @if (hasSession()) {
        <button type="button" class="btn btn-lg btn-outline-primary" [routerLink]="['/signup']">
          Order Now
        </button>
        } @else {
        <button type="button" class="btn btn-lg btn-outline-primary" (click)="openModal()">
          Set Up Delivery
        </button>
        }
        }
        }

      </div>

      <div class="doordarsh-logo">
        <img src="/assets/images/landing/home/hero/doordash-logo.webp" alt="Doordash Logo">
      </div>

    </div>

  </section>

  <!-- TESTIMONIALS -->
  <section class="home__testimonials" id="testimonial-section">

    <span class="icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="252" height="230" viewBox="0 0 252 230" fill="none">
        <path
          d="M32.3201 193.29C1.44002 183.238 -6.9752 156.632 7.07446 113.471C12.4195 97.0511 22.1917 79.4781 36.3913 60.752C50.7437 41.5568 65.5971 26.1567 80.9518 14.5517C96.3065 2.94661 107.909 -1.57811 115.76 0.977492C124.134 3.70347 126.489 10.6961 122.824 21.9555L85.6249 58.878C64.1408 80.4214 50.9665 96.887 46.1018 108.275C61.9133 107.714 72.6976 108.371 78.4549 110.245C85.7824 112.63 90.765 118.663 93.4028 128.342C96.1933 137.552 95.6796 148.021 91.8618 159.749C87.5858 172.885 79.7335 182.782 68.305 189.439C57.3999 196.266 45.4049 197.55 32.3201 193.29ZM157.411 227.784C143.28 223.184 134.47 212.014 130.983 194.276C128.019 176.708 129.82 157.837 136.387 137.664C146.619 106.232 175.529 76.9883 223.119 49.9338C229.575 47.8844 235.42 47.7116 240.654 49.4154C250.075 52.4821 253.563 57.7685 251.12 65.2748C249.898 69.0279 247.706 72.2058 244.544 74.8082C215.143 92.2182 196.364 106.341 188.207 117.175C179.962 130.057 175.075 138.843 173.548 143.535C171.868 148.695 170.483 154.73 169.392 161.639C178.988 160.611 187.711 161.376 195.562 163.931C204.983 166.998 212.07 171.899 216.824 178.635C222.101 185.541 223.518 192.748 221.074 200.254C218.478 208.229 209.405 215.653 193.854 222.524C178.457 228.927 166.309 230.68 157.411 227.784Z"
          fill="white" fill-opacity="0.05" />
      </svg>
    </span>

    <h2>
      What People Say:
    </h2>

    <blockquote>
      {{currentTestimony()?.testimony}}
    </blockquote>
    <cite>
      {{currentTestimony()?.author}}
    </cite>

    <div class="dots">
      @for (item of testimonials(); track $index) {
      <div [class.dot-active]="currentIndexTestimony() === $index" (click)="prevNextTestimonial($index)"></div>
      }
    </div>

  </section>

  <!-- HOW IT WORKS -->
  <section class="home__how-it-works" id="how-it-work-section">

    <img class="left-mask" src="/assets/images/landing/home/how-it-work/left-mask.svg" alt="">
    <img class="right-mask" src="/assets/images/landing/home/how-it-work/right-mask.svg" alt="">

    <h2>
      How it Works
    </h2>

    <div class="items">

      @for (item of howItWork(); track $index) {
      <div>

        <img src="/assets/images/landing/home/how-it-work/{{item.icon}}" alt="Image of {{item.title}}">

        <span class="h5-bold">
          {{item.title}}
        </span>

        <p class="h6-regular text-primary text-center">
          {{item.text}}
        </p>

      </div>
      }

    </div>

    @defer (on timer(0.5s)) {
    @if (isSessionLoaded()) {
    @if (hasSession()) {
    <button type="button" class="btn btn-lg btn-secondary" [routerLink]="['/shop']">
      Start Shopping
    </button>
    } @else {
    <button type="button" class="btn btn-lg btn-secondary" [routerLink]="['/signup']">
      Get Started Today
    </button>
    }
    }
    }

  </section>

  <!-- BANNER 1 -->
  <section class="home__banner-1">

    <div class="position-relative z-1">
      <h1>
        Premium Nutrition
      </h1>
      <div class="d-flex position-relative">
        <h1>
          For
        </h1>
        <img src="/assets/images/landing/home/banners/text.svg" alt="Text Dogs & Cats">
      </div>
    </div>

    <div class="overlay"></div>

  </section>

  <!-- WHY CHOOOSE US? -->
  <section class="home__why-choose_us" id="why-choose-us-section">

    <h2>
      Why Choose Us?
    </h2>

    <div class="content">

      <div class="left">

        @for (item of whyChooseUs(); track $index) {
        <div>

          <header>

            <img src="/assets/images/landing/home/why-choose-us/{{item.icon}}" alt="Icon for {{item.title}}">

            <h4>
              {{item.title}}
            </h4>

          </header>

          <p>
            {{item.text}}
          </p>

        </div>
        }

      </div>

      <div class="right">

        <div class="icon">
          <span class="material-symbols-outlined">
            arrow_back
          </span>
        </div>

        <img src="/assets/images/landing/home/why-choose-us/people.webp" alt="People image">
        <img class="paws" src="/assets/images/landing/home/our-promise/paws.svg" alt="Paws">

      </div>

    </div>

    @defer (on timer(0.5s)) {
    @if (isSessionLoaded()) {
    @if (hasSession()) {
    <button type="button" class="btn btn-lg btn-secondary" [routerLink]="['/shop']">
      Start Shopping
    </button>
    } @else {
    <button type="button" class="btn btn-lg btn-secondary" [routerLink]="['/signup']">
      Get Started Today
    </button>
    }
    }
    }

  </section>

  <!-- OUR PROMISE -->
  <section class="home__our-promise" id="about-us-section">

    <section class="our-promise" id="our-promise-section">

      <div class="left">
        <img class="back" src="/assets/images/landing/home/our-promise/back-customer.webp" alt="Customer">
        <img class="main" src="/assets/images/landing/home/our-promise/customer.webp" alt="Customer">
      </div>

      <div class="right">

        <div class="icon">
          <span class="material-symbols-outlined">
            arrow_back
          </span>
        </div>

        <div class="container">

          <h2>
            Our Promise
          </h2>

          <p class="h6-bold">
            We promise to share our knowledge and experience in pet nutrition, recommend solutions, and provide you with
            the best service a small business can.
          </p>

          <p class="h6-regular">
            if you have a brand you are loyal to, and would like us to provide you a nutrition comparison just call,
            email
            or visit our store and ask. We can do a side by side comparison of your current brand compared to ours. We
            have many more food options if your pet requires a special need for their food - please let us know what
            your
            pet requires and we'll work with our list of available suppliers to provide your pet with the food it needs.
          </p>

          <img src="/assets/images/landing/home/our-promise/paws.svg" alt="Paws">

        </div>

      </div>

    </section>

    <section class="our-founders" id="our-founders-section">

      <div class="left">

        <div class="icon">
          <span class="material-symbols-outlined">
            arrow_forward
          </span>
        </div>

        <div class="container founders">

          <h2>
            Our Founders
          </h2>

          <p class="h6-bold">
            In 2010, Michele Hobbs and Amanda Broughton noticed severe skin and coat issues with their pets.
          </p>

          <p class="h6-regular">
            Frustrated by costly vet visits and ineffective solutions, they discovered the problem: Mass-produced pet
            food
            lacked quality and nutritional value, despite 'premium' labels. The long shelf life further depleted its
            value. Feeling they'd let down their furry family members, they envisioned a solution. They wanted fresh,
            high-quality ingredients slow-cooked in small batches, delivered to your doorstep. This marked the start of
            a
            pet food revolution.
          </p>

          <img src="/assets/images/landing/home/our-promise/paws.svg" alt="Paws">

        </div>

      </div>

      <div class="right">
        <img class="back" src="/assets/images/landing/home/our-promise/back-family.webp" alt="Customer">
        <img class="main" src="/assets/images/landing/home/our-promise/family.webp" alt="Family">
      </div>

    </section>

    <section class="our-promise" id="our-brands-section">

      <div class="left">
        <img class="back" src="/assets/images/landing/home/our-promise/back-customer.webp" alt="Customer">
        <img class="main" src="/assets/images/landing/home/our-promise/brands.webp" alt="Customer">
      </div>

      <div class="right">

        <div class="icon">
          <span class="material-symbols-outlined">
            arrow_back
          </span>
        </div>

        <div class="container">

          <h2>
            Our Brands
          </h2>

          <p class="h6-bold">
            At Pet Wants, we’re always thinking about how to provide your pets with the very best in healthy nutrition.
            That’s why we created Shiny Dog—our exclusive line of housemade treats crafted with whole food ingredients,
            meaning zero fillers. Every batch is made fresh in our kitchen on Vine Street in Over-the-Rhine—seven days a
            week. From our dehydrated Liver Fries and freeze-dried Pawfait to our nutritious goat’s milk, you can feel
            confident knowing exactly what’s in your dog’s snacks. Wholesome, nutritious, and thoughtfully crafted from
            our own recipes—for happy, healthy pets.
          </p>

          <img src="/assets/images/landing/home/our-promise/paws.svg" alt="Paws">

        </div>

      </div>

    </section>

  </section>

  <!-- FAQS -->
  <section class="home__faqs" id="faqs-section">

    <h2>
      FAQS
    </h2>

    <div class="questions">
      @for (item of faqs(); track $index) {
      <div class="question" [class.active-question]="currentIndexFaqs() === $index">
        <header>

          <h4>
            {{item.question}}
          </h4>

          <span class="material-symbols-outlined" (click)="openFaq($index)">
            {{ currentIndexFaqs() === $index ? 'call_made' : 'south_east'}}
          </span>

        </header>

        @if (currentIndexFaqs() === $index) {
        <div class="answer">
          <div class="vertical-line"></div>
          <p [innerHTML]="item.answer"></p>
        </div>
        }

      </div>
      }
    </div>

  </section>

  <!-- SUBSCRIBE -->
  <section class="home__subscribe">

    <div>
      <h4>Subscribe to our newsletter</h4>
    </div>

    <app-klaviyo-forms [formId]="'XnaEF2'"></app-klaviyo-forms>

  </section>

</section>

<app-footer></app-footer>